const createMarkup = __html => ({ __html })

export default createMarkup
